const DEFAULT_GUEST_COUNT = 1

/** Parse adults/guests from form or URL; empty and "all" resolve to the default (1). */
export function parseGuestCount(value: string | undefined | null, defaultValue = DEFAULT_GUEST_COUNT): number {
  if (!value || value === 'all') return defaultValue
  const n = parseInt(value, 10)
  return Number.isFinite(n) && n > 0 ? n : defaultValue
}

/** Normalize for form state — always a positive integer string. */
export function normalizeGuestCount(value: string | undefined | null): string {
  return String(parseGuestCount(value))
}
